<app-img-header
  title="Plan Piso"
  alt="Plan Piso"
  image="/assets/images/catalogos/intro.jpg"
  [contentTemplate]="template"
>
</app-img-header>
<app-preloader *ngIf="isLoading"></app-preloader>
<app-notifications></app-notifications>

<main class="main">
  <div id="detail">
    <div class="pageWidth">
      <div class="actionsWrapper">
        <button class="tertiary" (click)="addNewWholesale()">
          <i class="icon"></i> Nuevo Plan Piso
        </button>
      </div>

      <div class="customTable listadoPlanPiso" *ngIf="data.length != 0">
        <div class="header">
          <div class="cell nombre">Nombre</div>
          <div class="cell dealer">Distribuidor</div>
          <div class="cell clave-mxn">Clave MXN</div>
          <div class="cell clave-usd">Clave USD</div>
          <div class="cell estado">Estado</div>
          <div class="cell acciones">Acciones</div>
        </div>

        <div class="row" *ngFor="let item of data">
          <div class="cell nombre">{{ item.name || '-' }}</div>
          <div class="cell dealer">{{ getDealerName(item.dealerId) }}</div>
          <div class="cell clave-mxn">{{ item.wholeSaleKeyMxn || '-' }}</div>
          <div class="cell clave-usd">{{ item.wholeSaleKeyUsd || '-' }}</div>
          <div class="cell estado">
            {{ item.active === 1 ? 'Activo' : 'Inactivo' }}
          </div>
          <div class="cell acciones">
            <a tp="Ver plan piso" class="view" (click)="view(item.id)">Ver</a>
          </div>
        </div>
      </div>

      <!--pagindador-->
      <div *ngIf="hasData">
        <app-paginator
          [total]="total"
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          (changePage)="handlePage($event)"
        ></app-paginator>
      </div>

      <div class="actionsWrapper">
        <button class="tertiary" (click)="addNewWholesale()">
          <i class="icon"></i> Nuevo Plan Piso
        </button>
      </div>
    </div>
    <ng-template #template>
      <div class="wrapperG4">
        <!---
        <div>
          <label>Nombre</label>
          <app-input
            [data]="searchName"
            (textSearch)="filter($event, 'name')"
            [resetInput]="reset"
          ></app-input>
        </div>-->
        <div>
          <label>Distribuidor</label>
          <app-select
            [options]="dealerOptions"
            [placeholder]="'Buscar por distribuidor'"
            (optionSelected)="filter($event, 'dealerId')"
            [resetSelect]="reset"
          ></app-select>
        </div>
        <!---
        <div>
          <label>Clave MXN</label>
          <app-input
            [data]="searchKeyMxn"
            (textSearch)="filter($event, 'wholeSaleKeyMxn')"
            [resetInput]="reset"
          ></app-input>
        </div>
        <div>
          <label>Clave USD</label>
          <app-input
            [data]="searchKeyUsd"
            (textSearch)="filter($event, 'wholeSaleKeyUsd')"
            [resetInput]="reset"
          ></app-input>
        </div>-->
        <div>
          <label>Estado</label>
          <app-select
            [options]="statusOptions"
            [placeholder]="'Buscar por estado'"
            (optionSelected)="filter($event, 'active')"
            [resetSelect]="reset"
          ></app-select>
        </div>
      </div>
      <div class="filtersActions">
        <button class="primary" (click)="search()">Buscar</button>
        <button class="secondary" (click)="resetFilters()">
          Limpiar filtros
        </button>
      </div>
    </ng-template>
  </div>
</main>

